import _ from 'lodash'
import axios from 'axios'

export default function apiRequest(url, data) {
  var request = {
    method: 'post',
    url: url,
    data: data,
    headers: {
      'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
      'X-Timezone-Offset': ((new Date()).getTimezoneOffset() / 60).toString()
    }
  }

  return axios(request).then(response => {
    // return response.data
  }).catch(error => {
    throw error
    // console.log('An error occurred:', error);
  })
}